import { render, staticRenderFns } from "./ShiftCalendar.vue?vue&type=template&id=1f4ddaa8&"
import script from "./ShiftCalendar.vue?vue&type=script&lang=js&"
export * from "./ShiftCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports